import React from "react";
import useNamedSlots from "helpers/useNamedSlots";
import Tag from "components/00-elements/tag";

// A Sub-Component for the description of the AboutUs component
const TeaserAbove = ({ children }) => <> {children} </>;
TeaserAbove.displayName = 'TeaserAbove';
// A Sub-Component for the description of the AboutUs component
const TeaserContent = ({ children }) => <> {children} </>;
TeaserContent.displayName = 'TeaserContent';
// A Sub-Component for the description of the AboutUs component
const TeaserBelow = ({ children }) => <> {children} </>;
TeaserBelow.displayName = 'TeaserBelow';

function Teaser({ children, containerClass, eyebrow, tag, tagTheme, title, url }) {
  const slots = useNamedSlots(children, ['TeaserAbove', 'TeaserContent', 'TeaserBelow']);

  return(
  <a href={url} title={`View ${title}`} className={`teaser surface--light-lightest-cream ${containerClass}`}>
    <div className="teaser__content">
      <div className="teaser__above">
        {/* Badge */}
        <Tag theme={tagTheme} text={tag}/>
        {/* Optional above */}
        { slots.TeaserAbove && slots.TeaserAbove }
      </div>
      {/* Optional eyebrow */}
      { eyebrow !== undefined && <span className='eyebrow'> { eyebrow } </span> }
      <h4 className='h3'> {title} </h4>
      <div className="teaser__body">
        { slots.TeaserContent && slots.TeaserContent }
      </div>
    </div>
    <div className="teaser__below">
      { slots.TeaserBelow && slots.TeaserBelow }
    </div>
  </a>);
}

Teaser.above = TeaserAbove;
Teaser.content = TeaserContent;
Teaser.below = TeaserBelow;

export default Teaser;
